module.exports = __webpack_public_path__ + "img/beer_id-93.c6959c06.png";